import { Pipe, PipeTransform, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'uiLabelTranslate',
  standalone: true,
  pure: false
})
export class UiLabelTranslatePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | null | undefined): string {
    const label = String(value ?? '');

    if (!label.trim()) {
      return label;
    }

    const key = `uiLabels.${this.toKey(label)}`;
    const translated = this.translate.instant(key);
    return translated === key ? label : translated;
  }

  private toKey(value: string): string {
    return value
      .trim()
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\+/g, ' plus ')
      .replace(/[^a-z0-9]+/g, '.')
      .replace(/^\.+|\.+$/g, '');
  }
}
